import React from 'react'

export const SchoolBellIcon: React.FC<{ color?: string; size?: number }> = ({ color = '#EBD76F', size = 24 }) => (
  <svg width={size} height={size} viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path
      d='M22 16L19 13V8C19 4.93 17.36 2.36 14.5 1.68V1C14.5 0.734784 14.3946 0.48043 14.2071 0.292893C14.0196 0.105357 13.7652 0 13.5 0H10.5C10.2348 0 9.98043 0.105357 9.79289 0.292893C9.60536 0.48043 9.5 0.734784 9.5 1V1.68C6.63 2.36 5 4.93 5 8V13L2 16V18H22V16ZM12 24C12.7956 24 13.5587 23.6839 14.1213 23.1213C14.6839 22.5587 15 21.7956 15 21H9C9 21.7956 9.31607 22.5587 9.87868 23.1213C10.4413 23.6839 11.2044 24 12 24Z'
      fill={color}
    />
  </svg>
)
